<template>
    <div class="compare-column">
        <div class="compare-title">
            <span>对比栏</span>
            <span class="comments">最多可加入10个</span>
            <!--<span class="operate">隐藏</span>-->
        </div>
        <div class="compare-content">
            <div class="compare-list">
                <div v-for="(bidDoc, index) in bidParityList" class="compare-item">
                    <a>{{bidDoc.merchantName}}</a>
                    <span>总报价（元）：<span class="font-red">{{bidDoc.offerPrice || '无'}}</span></span>
                    <span class="price"></span>
                    <i class="close-icon" @click="removeBidParity(index);">×</i>
                </div>
            </div>
            <div class="compare-operate">
                <button @click="openBidParityDlg()" class="swb-btn swb-btn-mini">对比</button>
                <!--<p class="mt10">清空对比栏</p>-->
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils, Store } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openBidParityDlg } from './selectDlg'
    //
    function getStore() {
        if(typeof Store != 'undefined') {
            return Store;
        } else {
            console.warn('请确保引入了 store.js');
        }
        //
        return null;
    }
    //
    export default{
        name: 'swb-bid-parity-center',
        desc: '比价中心',
        props: ['callBidDocId'],
        data: function () {
            return {
                bidParityKey: "bidParityKey",
                bidParityList: []
            }
        },
        created: function () {
            this.getBidParityList();
        },
        methods: {
            getBidParityList: function () {
                let store = getStore() || {};
                let bidParityList = store.get(this.bidParityKey) || [];
                this.bidParityList = bidParityList;
            },
            removeBidParity: function (index) {
                let self = this;
                this.$confirm('确定要移除吗 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let store = getStore() || {};
                    let bidParityList = store.get(self.bidParityKey) || [];
                    bidParityList.splice(index, 1);
                    store.set(self.bidParityKey, bidParityList);
                    self.getBidParityList();
                    self.$emit('notity-syncRefresh', true);
                });
            },
            openBidParityDlg: function () {
                let self = this;
                let store = getStore() || {};
                let bidParityList = store.get(self.bidParityKey) || [];
                if(bidParityList.length <= 0) {
                    MsgBox.warning("至少加入一个对比！");
                    return;
                }
                openBidParityDlg(this.callBidDocId, function (isTrue) {
                    self.getBidParityList();
                    self.$emit('notity-syncRefresh', true);
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/ParityCenter.vue